<div class="head-section mt--24 mb--24" [ngClass]="sectionclass">
<div *ngIf="titletag" class="text-primary mat-h3 section-tag">{{ titletag }}</div>
<h2 *ngIf="title" class="section-title" [innerHTML]="title"></h2>
<div *ngIf="subtitle" class="section-subtitle" [innerHTML]="subtitle"></div>
<ng-content></ng-content>
</div>